import Alert from "@mui/material/Alert";
import { useFacilityReadOnly } from "hooks/useFacilityReadOnly";
import { formatDateLikeForDisplay } from "util/dates";

type FacilityReadOnlyBannerProps = {
  facilityId?: string;
};

/**
 * The archived notice copy for an archived facility, given its archive date.
 * Exported so callers that have the date already loaded can build the same
 * Alert inline without duplicating this string.
 */
export function facilityArchivedAlertText(archivedAt: string): string {
  return `This facility was archived on ${formatDateLikeForDisplay(archivedAt)}. It is retained for historical records only.`;
}

/**
 * Renders an error alert when a facility has been archived.
 * Renders nothing when the facility is not read-only.
 */
export function FacilityReadOnlyBanner({ facilityId }: FacilityReadOnlyBannerProps) {
  const { isReadOnly, archivedAt } = useFacilityReadOnly(facilityId);

  if (!isReadOnly || !archivedAt) {
    return null;
  }

  return (
    <Alert severity="error" sx={{ mx: 2, mt: 2 }}>
      {facilityArchivedAlertText(archivedAt)}
    </Alert>
  );
}
